import getMuiTheme from 'material-ui/styles/getMuiTheme';

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: "#31b59f",
    accent1Color: "#337ab7"
  }
});

export default muiTheme;



// WEBPACK FOOTER //
// ./src/utils/muiTheme.js